<div class="p-5 d-none d-md-block"></div>
<div class="container-fluid d-none d-md-block">
  <div class="container popGrid">
    <div class="mailGrid">
      <div class="gridItem">
        <div class="joinMail">
          <div class="d-flex">
            <h4 style="font-family: Poppins;
              font-size: 18px;
              font-style: normal;
              font-weight: 600;
              line-height: 22px;
              letter-spacing: 0em;
              text-align: left;
              ">
              <span class="svgHolder">
                <svg width="42" height="32" viewBox="0 0 42 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M38.0625 0H3.93753C1.76624 0 0 1.76624 0 3.93753V27.5625C0 29.7338 1.76624 31.5 3.93753 31.5H38.0625C40.2338 31.5 42 29.7338 42 27.5625V3.93753C42 1.76624 40.2338 0 38.0625 0ZM38.0625 2.62499C38.2408 2.62499 38.4104 2.66199 38.5655 2.7266L21 17.9508L3.43438 2.7266C3.58947 2.66207 3.75911 2.62499 3.93744 2.62499H38.0625ZM38.0625 28.875H3.93753C3.21336 28.875 2.62499 28.2867 2.62499 27.5624V5.49993L20.1399 20.6796C20.3873 20.8936 20.6937 21 21 21C21.3063 21 21.6127 20.8937 21.8601 20.6796L39.375 5.49993V27.5625C39.3749 28.2867 38.7866 28.875 38.0625 28.875Z"
                    fill="black" />
                </svg>
              </span>
              Join Our Mailing List
            </h4>
          </div>
          <div class="mt-4" style="width: 288px;">
            <p style="font-family: Poppins;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 21px;
            letter-spacing: 0em;
            text-align: left;
            ">
              Subscribe to our newsletter to get updates on our latest offers!
            </p>
          </div>
          <div class="mt-4">
            <input class="newsLetter form-control" placeholder="Enter Email Address Here" >
          </div>
          <div class="mt-4">
           <button class="newsLetterButton">
              Subscribe
           </button>
          </div>
        </div>
      </div>
      <div class="gridItem d-none d-md-block">
        <img class="img-fluid" style="height: 100%;"
          src="https://res.cloudinary.com/dfqkwnen0/image/upload/v1602260393/Rectangle_23_vclq65.png" alt="Candilier">
      </div>
    </div>
  </div>
</div>
<div class="p-2 d-none d-md-block"></div>
